import React from 'react';
import PropTypes from 'prop-types';
import SpotListItemBase, {
    SPOTLISTITEM_PROP_TYPES,
    SPOTLISTITEM_IMAGE_DIMENSIONS,
} from './SpotListItemBase';
import FacilitySummary from 'common/facility-details/FacilitySummary';

const SpotListItemTransient = props => {
    const {
        isMobile,
        spot,
        isAdmin,
        isLowInventoryEnabled,
        isSoldOutEnabled,
    } = props;
    const {available_transient_inventory: transientInventory} = spot;
    const {
        width: imageWidth,
        height: imageHeight,
    } = SPOTLISTITEM_IMAGE_DIMENSIONS(isMobile);

    const isSoldOut = isSoldOutEnabled && transientInventory === 0 && !isAdmin;
    const showDetailsBtn =
        !isSoldOutEnabled && !isLowInventoryEnabled && !isMobile;

    return (
        <SpotListItemBase
            {...props}
            showDetailsButton={showDetailsBtn}
            showBookButton // always true for Transient
            isSoldOut={isSoldOut}
            FacilitySummary={
                <FacilitySummary
                    spot={spot}
                    priceLabel="total"
                    availableInventory={transientInventory}
                    lowInventoryThreshold={2}
                    imageWidth={imageWidth}
                    imageHeight={imageHeight}
                    isAdmin={isAdmin}
                    isLowInventoryEnabled={isLowInventoryEnabled}
                />
            }
        />
    );
};

SpotListItemTransient.propTypes = {
    ...SPOTLISTITEM_PROP_TYPES,
    isLowInventoryEnabled: PropTypes.bool,
    isSoldOutEnabled: PropTypes.bool,
};

export default SpotListItemTransient;
